import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import HashList from '../../utils/hashlist'

import { EDITOR__UPDATE_ACTIVE_POPUP_ID } from '../../store/actions/editor'

import './PopupNav.scss'

const Item = ({ selected = false, imgSrc, text = '', onClick }) => {
    return (
        <div
            className={`popup-nav__item${selected ? ' selected' : ''}`}
            onClick={evt => (selected ? evt.preventDefault() : onClick(evt))}
        >
            {imgSrc ? <div className="img" style={{ backgroundImage: `url(${imgSrc})` }}></div> : null}
            <span>{text}</span>
            {selected ? (
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="28" height="28" rx="14" fill="#2990FB" />
                    <path
                        d="M7.5 12C7.5 9.51472 9.51472 7.5 12 7.5H16C18.4853 7.5 20.5 9.51472 20.5 12V20.5H12C9.51472 20.5 7.5 18.4853 7.5 16V12Z"
                        stroke="white"
                    />
                    <line x1="11.5" y1="12.5" x2="16.5" y2="12.5" stroke="white" strokeLinecap="round" />
                    <line x1="11.5" y1="15.5" x2="14.5" y2="15.5" stroke="white" strokeLinecap="round" />
                </svg>
            ) : (
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="28" height="28" rx="14" fill="#69B1FC" />
                    <path
                        d="M7.5 12C7.5 9.51472 9.51472 7.5 12 7.5H16C18.4853 7.5 20.5 9.51472 20.5 12V20.5H12C9.51472 20.5 7.5 18.4853 7.5 16V12Z"
                        stroke="white"
                    />
                    <line x1="11.5" y1="12.5" x2="16.5" y2="12.5" stroke="white" strokeLinecap="round" />
                    <line x1="11.5" y1="15.5" x2="14.5" y2="15.5" stroke="white" strokeLinecap="round" />
                </svg>
            )}
        </div>
    )
}

const PopupNav = ({}) => {
    const { screens, activeScreenId, activePopupId } = useSelector(state => state.editor)
    const dispatch = useDispatch()

    const activeScreen = screens.filter(({ hashlistId }) => hashlistId === activeScreenId)[0]

    const popups = activeScreen ? new HashList(activeScreen.popups).toArray() : []
    const components = activeScreen ? new HashList(activeScreen.components).toArray() : []

    const getComponent = id => components.filter(({ data }) => data && data.popupId === id)[0]
    const getText = html => (html.match(/[^<>]+(?=[<])/) || [void 0])[0]

    return (
        <div className="popup-nav">
            {popups.map(popup => {
                const bind = getComponent(popup.hashlistId)
                if (!bind) return null
                const text = getText(bind.text)
                const imgSrc = bind.imageSrc

                return (
                    <Item
                        key={popup.hashlistId}
                        selected={popup.hashlistId === activePopupId}
                        imgSrc={text ? null : imgSrc}
                        text={text}
                        onClick={() => {
                            dispatch(EDITOR__UPDATE_ACTIVE_POPUP_ID(popup.hashlistId))
                        }}
                    />
                )
            })}
        </div>
    )
}

export default PopupNav
